/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "cms/icons";

const DocumentCard = (props) => {
    
    const { displayWidth, displayHeight, fileExt = "pdf", fontSize="6rem" } = props;
    const { selectedDocument } = useContext(DocumentEditContext);
    let { width = 0, height = 0 } = selectedDocument || {};
    const defaultWidth = "100%";
    const defaultHeight = 160;
    // use defaults if 0
    width = (width === 0) ? defaultWidth : width;
    height = (height === 0) ? defaultHeight : height;
    // use display width/height if supplied
    width = displayWidth ? displayWidth : width;
    height = displayHeight ? displayHeight : height;
    const cover_document_style = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: width,
        height: height,
    };
    const { regular } = icons;
    const { faFileWord, faFileExcel } = regular;
    const isPDF = fileExt === "pdf";
    const isWord = fileExt === "doc" || fileExt === "docx";
    const isExcel = fileExt === "xlsx" || fileExt === "xls";
    const isUnknownDocType = !isPDF && !isWord && !isExcel;
    
    return (
        <div
            id='simplicity-cover-document'
            className='simplicity-cover-document-edit cover'
            style={cover_document_style}
        >
            {isPDF &&
                <FontAwesomeIcon
                    // icon={faFilePdf}
                    icon={"fa-regular fa-file-pdf"}
                    fontSize={fontSize || "6rem"}
                    color='#7A7A7A'
                />
            }
            {isWord &&
                <FontAwesomeIcon
                    icon={faFileWord}
                    fontSize={fontSize || "6rem"}
                    color='#7A7A7A'
                />
            }
            {isExcel && 
                <FontAwesomeIcon 
                    icon={faFileExcel}
                    fontSize={fontSize || "6rem"}
                    color='#7A7A7A'
                />
            }
            {isUnknownDocType && 
                <FontAwesomeIcon 
                    icon={"fa-regular fa-file"}
                    fontSize={fontSize || "6rem"}
                    color='#7A7A7A'
                />
            }
        </div>
    );
};
export { DocumentCard };
